import { TermsOfServiceContent } from '../types';

export const termsOfServiceContent: TermsOfServiceContent = {
  heading: 'Terms of Service',
  lastUpdated: 'May 19, 2025',
  disclaimer: 'Please read these Terms of Service carefully before using our platform. These terms establish the rules and guidelines for accessing and using AZ1.AI services. By using our platform, you agree to these terms in their entirety.',
  sections: [
    {
      title: 'Agreement to Terms',
      paragraphs: [
        'By accessing or using the services provided by AZ1.AI ("we," "us," or "our"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.',
        'We may update these Terms of Service from time to time. Your continued use of our services after such changes constitutes your acceptance of the new terms.'
      ]
    },
    {
      title: 'Services Description',
      paragraphs: [
        'AZ1.AI provides agentic systems development, deployment, and integration services for enterprise solutions. Our services may include:',
      ],
      bulletPoints: [
        'Agentic system development and customization',
        'Multi-agent system architecture and implementation',
        'Cognitive architecture design',
        'Integration with existing enterprise systems',
        'Deployment infrastructure setup and maintenance',
        'Training and support services'
      ]
    },
    {
      title: 'User Responsibilities',
      paragraphs: [
        'As a user of our services, you agree to:',
      ],
      bulletPoints: [
        'Provide accurate and complete information when using our services',
        'Maintain the security of your account credentials',
        'Use our services only for lawful purposes and in accordance with these Terms',
        'Not attempt to gain unauthorized access to any portion of our platform',
        'Not use our services in any manner that could damage, disable, overburden, or impair our systems',
        'Respect the intellectual property rights of AZ1.AI and other third parties'
      ]
    },
    {
      title: 'Intellectual Property Rights',
      paragraphs: [
        'All content, features, and functionality of our services, including but not limited to text, graphics, logos, icons, images, audio clips, data compilations, and software, are the exclusive property of AZ1.AI or our licensors and are protected by copyright, trademark, and other intellectual property laws.',
        'You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any materials from our services without our prior written consent, except as provided in these Terms of Service.'
      ]
    },
    {
      title: 'Data Privacy and Security',
      paragraphs: [
        'We take data privacy and security seriously. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms of Service by reference.',
        'You acknowledge that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.'
      ]
    },
    {
      title: 'Limitation of Liability',
      paragraphs: [
        'To the fullest extent permitted by applicable law, AZ1.AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or use, arising out of or in connection with your use of our services.',
        'Our total liability for all claims arising from or related to your use of our services shall not exceed the amount paid by you, if any, for accessing our services during the twelve (12) months preceding the claim.'
      ]
    },
    {
      title: 'Indemnification',
      paragraphs: [
        'You agree to defend, indemnify, and hold harmless AZ1.AI, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys\' fees) arising out of or relating to your violation of these Terms of Service or your use of the services.'
      ]
    },
    {
      title: 'Governing Law and Jurisdiction',
      paragraphs: [
        'These Terms of Service shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law principles.',
        'Any legal suit, action, or proceeding arising out of or related to these Terms of Service or our services shall be instituted exclusively in the federal courts of the United States or the courts of the State of California, although we retain the right to bring any suit, action, or proceeding against you for breach of these Terms of Service in your country of residence or any other relevant country.'
      ]
    },
    {
      title: 'Termination',
      paragraphs: [
        'We may terminate or suspend your access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms of Service.',
        'Upon termination, your right to use our services will immediately cease.'
      ]
    },
    {
      title: 'Contact Information',
      paragraphs: [
        'If you have any questions about these Terms of Service, please contact us:',
        'By email: legal@az1.ai',
        'By phone: +1 (555) 123-4567',
        'By mail: AZ1 Technologies, 123 Tech Street, San Francisco, CA 94105'
      ]
    }
  ]
};

export default {
  termsOfServiceContent
};